import type { PrV2CheckBucket, PrV2CheckSummary } from '@/lib/pr-v2/check-run-presentation';
import type { LucideIcon } from 'lucide-react';
import { Check, Ellipsis, X } from 'lucide-react';

// Marks inherit the metadata line's grey, failing included: a failing check
// reads by its mark, not by red. The inbox row draws `Icon`; the desktop tray's
// plain-text line writes `mark`.
const INBOX_CHECK_STATUS_PRESENTATION: Record<
  PrV2CheckBucket,
  {
    mark: string;
    Icon: LucideIcon;
    count: (checks: PrV2CheckSummary) => string;
  }
> = {
  failed: {
    mark: '×',
    Icon: X,
    count: (checks) => `${checks.failed}/${checks.total}`,
  },
  running: {
    mark: '…',
    Icon: Ellipsis,
    count: (checks) => `${checks.passed}/${checks.total}`,
  },
  passed: {
    mark: '✓',
    Icon: Check,
    count: (checks) => `${checks.passed}/${checks.total}`,
  },
};

function inboxCheckStatusTone(checks: PrV2CheckSummary): PrV2CheckBucket {
  if (checks.failed > 0) {
    return 'failed';
  }

  if (checks.running > 0) {
    return 'running';
  }

  return 'passed';
}

function describeInboxCheckStatus(checks: PrV2CheckSummary): string {
  const parts: string[] = [];

  if (checks.failed > 0) {
    parts.push(`${checks.failed} failing`);
  }

  if (checks.running > 0) {
    parts.push(`${checks.running} running`);
  }

  if (checks.passed > 0) {
    parts.push(`${checks.passed} passing`);
  }

  return parts.length > 0 ? parts.join(', ') : 'No checks';
}

export function getInboxCheckStatusPresentation(checks: PrV2CheckSummary) {
  const presentation = INBOX_CHECK_STATUS_PRESENTATION[inboxCheckStatusTone(checks)];

  return {
    mark: presentation.mark,
    Icon: presentation.Icon,
    count: presentation.count(checks),
    description: describeInboxCheckStatus(checks),
  };
}
